// @ts-strict-ignore
import * as React from 'react';
type ConnectorContext = {
  // One to Many mapping for event to properties
  leftRef: React.RefObject<HTMLDivElement>;
  setLeftRef: React.Dispatch<React.SetStateAction<React.RefObject<HTMLDivElement>>>;
  rightRefs: Array<React.RefObject<HTMLDivElement>>;
  setRightRefs: React.Dispatch<React.SetStateAction<Array<React.RefObject<HTMLDivElement>>>>;
  selectedRef: React.RefObject<HTMLDivElement>;
  setSelectedRef: React.Dispatch<React.SetStateAction<React.RefObject<HTMLDivElement>>>;
  parentRef: React.RefObject<HTMLDivElement>;
};
export const ConnectorContext = React.createContext<ConnectorContext>(null);